/* eslint react-hooks/exhaustive-deps: "warn" */

import { useEffect, useState } from 'react';

import { useInt } from 'hooks/useInt';

import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';
import { Section } from 'ui/molecules/Section/Section';

import styles from './RegisHero.module.scss';

import type { RegisHeroProps } from './RegisHero.types';

type Translate = (key: string) => string;

const getSampleQueries = (t: Translate): string[] => [
  t('Is Global Data Intelligence Limited still active?'),
  t('Who ultimately owns this company?'),
  t("What was last year's revenue, and where's that from?"),
  t('Has ownership changed in the last 12 months?'),
];

export const RegisHero = ({ title, description, actions }: RegisHeroProps) => {
  const { t } = useInt();
  const [queryIndex, setQueryIndex] = useState(0);

  const sampleQueries = getSampleQueries(t);

  useEffect(() => {
    const id = setInterval(() => {
      setQueryIndex((current) => (current + 1) % sampleQueries.length);
    }, 3200);

    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Section className={styles.root}>
      <div className={styles.glowBlue} />
      <div className={styles.glowIndigo} />

      <div className={styles.grid}>
        <div className={styles.titleCol}>
          <TitleBlock size="page" align="left" title={title} />
        </div>

        <div className={styles.sideCol}>
          <p className={styles.lede}>{description}</p>

          <div className={styles.query} aria-hidden="true">
            <span className={styles.queryChevron}>&gt;</span>
            <span key={queryIndex} className={styles.queryText}>
              {sampleQueries[queryIndex]}
            </span>
            <span className={styles.cursor} />
          </div>

          {actions && <div className={styles.actions}>{actions}</div>}
        </div>
      </div>
    </Section>
  );
};
